import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { generateUtmExt } from '../../common/common';
import {
  ASK_CLIR_TOPICS,
  ASk_CLIR_TOPICS_DETAILS,
  DIAGNOISIS_TOPICS_DETAILS,
  DIAGNOISIS_TOPIC_LIST
} from '../QueryKeys/askclir.key';
import axios from 'axios';
import appConfig from '../../config/config';

// const staleTime = 300000;
const cacheTime = 600000;
const url = appConfig.apiLoc;
const createThreadId = (data) => {
  return axiosInstance.post('bot/askDiagnosisGetTopicML', data);
};

export const useCreateThread = (onSuccess) => {
  const queryClient = useQueryClient();
  return useMutation(createThreadId, {
    onMutate: (newEdu) => {
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      queryClient.setQueryData(USER_PROFILE_ALL, context.previousData);
    },
    onSettled: (_err, _obj, context) => {
      // queryClient.invalidateQueries(USER_PROFILE_ALL);
    },
    onSuccess
  });
};

export const useGetTopicList = (onSuccess, enabled) => {
  return useInfiniteQuery(
    ASK_CLIR_TOPICS,
    ({ pageParam = 0 }) => axiosInstance.get(`bot/historyQNAlist?from=${pageParam}&to=10`),
    {
      refetchOnWindowFocus: false,
      cacheTime: cacheTime,
      onSuccess,
      enabled,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length > 0) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
      // onSuccess,
      // select: res => res.data.data
    }
  );
};

const fetchTopicDetails = ({ queryKey }) => {
  const id = queryKey[1];
  return axiosInstance.get(`bot/historyDiagnosisbyTopic?topic_id=${id}${generateUtmExt()}`);
};

export const useGetTopicDetails = (id, onSuccess, onError, queryEnabled) => {
  const queryClient = useQueryClient();
  return useQuery([ASk_CLIR_TOPICS_DETAILS, id], fetchTopicDetails, {
    // initialData: () => {
    //   // const medwikiFeatured = queryClient
    //   //   .getQueryData(MEDWIKI_FEATURED)
    //   //   ?.data?.data?.find((_m) => _m.type_id == id);
    //   // const medwiki = medwikiFeatured || medwikiVault || medwikiDashboard;
    //   // if (medwiki) {
    //   //   return { data: { data: medwiki } };
    //   // } else {
    //   //   return undefined;
    //   // }
    // },
    select: (response) => response.data.data,
    onSuccess,
    onError,
    enabled: queryEnabled,
    cacheTime: cacheTime,
    refetchOnWindowFocus: false
  });
};

export const useGetDiagnosisTopicList = (onSuccess, enabled) => {
  return useInfiniteQuery(
    DIAGNOISIS_TOPIC_LIST,
    ({ pageParam = 0 }) => axiosInstance.get(`bot/historyDiagnosislist?from=${pageParam}&to=10`),
    {
      refetchOnWindowFocus: false,
      cacheTime: cacheTime,
      onSuccess,
      enabled,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length > 0) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      },
      onSuccess
    }
  );
};

const fetchDiagnosisDetails = ({ queryKey }, isPublic) => {
  const id = queryKey[1];
  return isPublic
    ? axios.get(`${url}openbot/historyDiagnosisbyTopic?topic_id=${id}${generateUtmExt()}`)
    : axiosInstance.get(`bot/historyDiagnosisbyTopic?topic_id=${id}${generateUtmExt()}`);
};

export const useDiagnoisticTopicDetails = (
  id,
  onSuccess,
  onError,
  queryEnabled,
  isPublic = false
) => {
  const queryClient = useQueryClient();
  return useQuery(
    [DIAGNOISIS_TOPICS_DETAILS, id],
    (data) => fetchDiagnosisDetails(data, isPublic),
    {
      // initialData: () => {
      //   // const medwikiFeatured = queryClient
      //   //   .getQueryData(MEDWIKI_FEATURED)
      //   //   ?.data?.data?.find((_m) => _m.type_id == id);
      //   // const medwiki = medwikiFeatured || medwikiVault || medwikiDashboard;
      //   // if (medwiki) {
      //   //   return { data: { data: medwiki } };
      //   // } else {
      //   //   return undefined;
      //   // }
      // },
      select: (response) => response.data.data,
      onSuccess,
      onError,
      enabled: queryEnabled,
      cacheTime: cacheTime,
      refetchOnWindowFocus: false
    }
  );
};
const fetchOpenDiagnosisDetails = ({ queryKey }, isPublic) => {
  const id = queryKey[1];
  return isPublic
    ? axios.get(`${url}openbot/historyDiagnosisbyTopic?topic_id=${id}${generateUtmExt()}`)
    : axios.get(`${url}openapi/historyDiagnosisbyTopic?topic_id=${id}${generateUtmExt()}`);
};

export const useOpenDiagnoisticTopicDetails = (id, onSuccess, onError, queryEnabled, isPublic) => {
  const queryClient = useQueryClient();
  return useQuery(
    [DIAGNOISIS_TOPICS_DETAILS, id],
    (data) => fetchOpenDiagnosisDetails(data, isPublic),
    {
      // initialData: () => {
      //   // const medwikiFeatured = queryClient
      //   //   .getQueryData(MEDWIKI_FEATURED)
      //   //   ?.data?.data?.find((_m) => _m.type_id == id);
      //   // const medwiki = medwikiFeatured || medwikiVault || medwikiDashboard;
      //   // if (medwiki) {
      //   //   return { data: { data: medwiki } };
      //   // } else {
      //   //   return undefined;
      //   // }
      // },
      select: (response) => response.data.data,
      onSuccess,
      onError,
      enabled: queryEnabled,
      cacheTime: cacheTime,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
};
